export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      function push () {
        window.hj.q = window.hj.q || []
        // eslint-disable-next-line prefer-rest-params
        window.hj.q.push(arguments)
      }
      const settings = {
        hjid: toolId,
        hjsv: 6,
      }
      window.hj = window.hj || push
      window._hjSettings = settings
      const head = document.getElementsByTagName('head')[0]
      const script = document.createElement('script')
      script.async = true
      script.src = `https://static.hotjar.com/c/hotjar-${settings.hjid}.js?sv=${settings.hjsv}`
      head.appendChild(script)
    },
  })
}
